/**
 * Auth service — cookie-based sessions (ADR-005) with refresh rotation.
 * Tokens live in httpOnly cookies set by the backend; the client never stores them.
 */
import apiClient from '@/services/api/client';

/** @param {{email:string,password:string}} credentials */
export async function login(credentials) {
        const { data } = await apiClient.post('/v1/auth/login', credentials);
        return data; // { user, tokens } — tokens ignored (httpOnly cookies)
}

export async function me() {
        const { data } = await apiClient.get('/v1/auth/me');
        return data;
}

export async function logout() {
        await apiClient.post('/v1/auth/logout');
}

/** Change own password (verifies current). Backend revokes other sessions. */
export async function changePassword({ current_password, new_password }) {
        await apiClient.post('/v1/auth/change-password', { current_password, new_password });
}


/** Fetch the RBAC matrix (backend = source of truth for permissions). */
export async function fetchRbacMatrix() {
        const { data } = await apiClient.get('/v1/meta/rbac');
        return data.roles;
}

/** Server-authoritative UI config (demo mode + demo account when enabled). */
export async function fetchPublicConfig() {
        const { data } = await apiClient.get('/v1/meta/config');
        return data; // { app_env, demo_mode, demo_account }
}
